<template>
  <div class="footer">
    <div class="footerup">
      <div class="pd">
        <span>{{ $t("footerTitle1") }}</span>
        <div>
          <ul>
            <router-link to="">
              <li>
                <div class="img-container">
                  <img
                    src="@/assets/footerpic/footer-1.png"
                    alt=""
                    class="img-default"
                  />
                  <img
                    src="@/assets/footerpic/footeron-1.png"
                    alt=""
                    class="img-hover"
                  />
                </div>
                {{ $t("footerText1") }}
              </li>
            </router-link>
            <router-link to="/footDetail/pd2">
              <li>
                <div class="img-container">
                  <img
                    src="@/assets/footerpic/footer-2.png"
                    alt=""
                    class="img-default"
                  />
                  <img
                    src="@/assets/footerpic/footeron-2.png"
                    alt=""
                    class="img-hover"
                  />
                </div>
                {{ $t("footerText2") }}
                <p class="pd-nextline">{{ $t("footerText3") }}</p>
              </li>
            </router-link>
            <router-link to="/footDetail/pd3">
              <li>
                <div class="img-container">
                  <img
                    src="@/assets/footerpic/footer-3.png"
                    alt=""
                    class="img-default"
                  />
                  <img
                    src="@/assets/footerpic/footeron-3.png"
                    alt=""
                    class="img-hover"
                  />
                </div>
                {{ $t("footerText16") }}
              </li>
            </router-link>
            <router-link to="/footDetail/pd4">
              <li>
                <div class="img-container">
                  <img
                    src="@/assets/footerpic/footer-4.png"
                    alt=""
                    class="img-default"
                  />
                  <img
                    src="@/assets/footerpic/footeron-4.png"
                    alt=""
                    class="img-hover"
                  />
                </div>
                {{ $t("footerText17") }}
              </li>
            </router-link>
            <router-link to="/footDetail/pd5">
              <li>
                <div class="img-container">
                  <img
                    src="@/assets/footerpic/footer-5.png"
                    alt=""
                    class="img-default"
                  />
                  <img
                    src="@/assets/footerpic/footeron-5.png"
                    alt=""
                    class="img-hover"
                  />
                </div>
                {{ $t("footerText18") }}
              </li>
            </router-link>
            <router-link to="/footDetail/pd6">
              <li>
                <div class="img-container">
                  <img
                    src="@/assets/footerpic/footer-6.png"
                    alt=""
                    class="img-default"
                  />
                  <img
                    src="@/assets/footerpic/footeron-6.png"
                    alt=""
                    class="img-hover"
                  />
                </div>
                {{ $t("footerText19") }}
              </li>
            </router-link>
            <router-link to="/footDetail/pd7">
              <li>
                <div class="img-container">
                  <img
                    src="@/assets/footerpic/footer-7.png"
                    alt=""
                    class="img-default"
                  />
                  <img
                    src="@/assets/footerpic/footeron-7.png"
                    alt=""
                    class="img-hover"
                  />
                </div>
                {{ $t("footerText20") }}
              </li>
            </router-link>
          </ul>
          <div class="pd-span">
            <span>{{ $t("footerTitle5") }}</span>
            <ul>
              <router-link to="/footDetail/pd8">
                <li>
                  <div class="img-container">
                    <img
                      src="@/assets/footerpic/footer-8.png"
                      alt=""
                      class="img-default"
                    />
                    <img
                      src="@/assets/footerpic/footeron-8.png"
                      alt=""
                      class="img-hover"
                    />
                  </div>
                  {{ $t("footerText21") }}
                </li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
      <div class="gs">
        <span>{{ $t("footerTitle2") }}</span>
        <div>
          <ul>
            <router-link to="/about">
              <li>{{ $t("footerText4") }}</li>
            </router-link>
            <router-link to="/news">
              <li>{{ $t("footerText5") }}</li>
            </router-link>
          </ul>
        </div>
      </div>
      <div class="fl">
        <span>{{ $t("footerTitle3") }}</span>
        <div>
          <ul>
            <router-link to="/laws/access-declaration">
              <li>{{ $t("footerText6") }}</li>
            </router-link>
            <router-link to="/laws/terms-of-use">
              <li>{{ $t("footerText7") }}</li>
            </router-link>
          </ul>
        </div>
      </div>
      <div class="lx">
        <span>{{ $t("footerTitle4") }}</span>
        <div>
          <ul>
            <a href="https://j.map.baidu.com/27/w0ei">
              <li>
                <p>{{ $t("footerText14") }}</p>
                {{ $t("footerText8") }}
              </li>
            </a>
            <a
              href="https://map.baidu.com/search/%E6%9D%AD%E5%B7%9E%E5%B8%82%E6%A1%90%E5%BA%90%E5%8E%BF%E5%AE%9D%E5%BF%83%E8%B7%AF356%E5%8F%B7%E8%BF%8E%E4%B8%B0%E5%9B%BD%E9%99%85%E4%BA%A7%E4%B8%9A%E5%9B%AD11%E5%B9%A2/@13328489,3458609.5,19z?querytype=s&da_src=shareurl&wd=%E6%9D%AD%E5%B7%9E%E5%B8%82%E6%A1%90%E5%BA%90%E5%8E%BF%E5%AE%9D%E5%BF%83%E8%B7%AF356%E5%8F%B7%E8%BF%8E%E4%B8%B0%E5%9B%BD%E9%99%85%E4%BA%A7%E4%B8%9A%E5%9B%AD11%E5%B9%A2&c=179&src=0&pn=0&sug=0&l=19&b=(13327760,3458290.25;13328784,3458785.75)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
            >
              <li>
                <p>{{ $t("footerText15") }}</p>
                {{ $t("footerText9") }}
              </li>
            </a>
            <li>{{ $t("footerText10") }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div>
      <div class="links-bottom"></div>
    </div>
    <div class="footerdown">
      <div class="footerdowntext">
        <span>{{ $t("footerText11") }}</span>
        <div>
          <span>{{ $t("footerText12") }}</span>
        </div>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">
          <div>
            <span>{{ $t("footerText13") }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
.footer {
  padding: 60px 0 30px 0;
  background-color: #f5f5f5;
}

.footerup {
  display: grid;
  grid-template-columns: minmax(0, 4fr) minmax(0, 1fr) minmax(0, 4fr) minmax(0, 3fr);
  gap: 10px;
}

.pd,
.gs,
.fl,
.lx {
  text-align: left;
  padding: 0 10px;
  min-width: 0;
}

.gs,
.fl {
  white-space: nowrap;
}

.lx {
  white-space: normal;
  word-wrap: break-word;
}

.footerup ul {
  padding: 0;
  margin: 0;
}

.footerup li {
  list-style-type: none;
  font-size: 16px;
  padding-top: 10px;
  color: #6c6c83;
  line-height: 1.45;
  overflow-wrap: anywhere;

  /* position: relative; */
}

.footerup span {
  letter-spacing: 5px;
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}

.footerdown {
  padding-top: 50px;
  font-size: 16px;
}

.links-bottom {
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 50px;
  padding: 0.5px;
  background-color: #018fd7;
}

.footerup li:hover {
  color: #018fd7;
}

.footerup li:hover .img-default {
  display: none;
}

.footerup li:hover .img-hover {
  display: inline;
}

.img-text {
  display: flex;
  align-items: center;
}

.img-container {
  display: inline-block;
  /* position: relative; */
  margin-right: 10px; /* 添加图片和文字之间的间距 */
}

.img-default,
.img-hover {
  height: 23px;
  display: inline;
}

.img-hover {
  display: none;
}

a {
  text-decoration: none;
  color: inherit;
}

.footer a:hover {
  color: #018fd7;
  text-decoration: underline;
}

.lx p {
  margin: 0;
  padding: 0;
  text-decoration: underline;
}

.pd {
  padding-left: 8vw;
  white-space: normal;
}

/* .pd li{
  white-space: pre-wrap;

} */

.pd-span {
  margin-top: 20px;
}

.pd-nextline {
  padding-left: 102px;
  margin: 0;
}

.lx span {
  display: block;
}
@media (max-width: 768px) {
  .footerup {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .footer {
    padding: 3vh 0;
  }

  .footerdown {
    padding-top: 3vh;
  }

  .links-bottom {
    margin-top: 3vh;
  }

  .footerup li {
    padding: 0.7vh 0 0 6vw;
  }

  .pd {
    padding-left: 10px;
  }
  .pd li {
    word-break: break-all;
    white-space: normal;
  }

  .pd-nextline {
    display: inline;
    margin: 0;
    padding: 0;
  }

  .lx {
    padding-left: 10px;
  }
}

@media (max-width: 1024px) {
  .footerup {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .footer {
    padding: 3vh 0;
  }

  .footerdown {
    padding-top: 3vh;
  }

  .links-bottom {
    margin-top: 3vh;
  }

  .footerup li {
    padding: 0.7vh 0 0 6vw;
  }

  .pd {
    padding-left: 10px;
  }
  .pd li {
    word-break: break-all;
    white-space: normal;
  }

  .pd-nextline {
    display: inline;
    margin: 0;
    padding: 0;
  }

  .lx {
    padding-left: 10px !important;
  }
}

@media (min-width: 1025px) and (max-width: 1220px) {
  .footerup {
    grid-template-columns: minmax(0, 5fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-auto-rows: auto;
  }

  .lx {
    grid-column: 1 / -1; /* 让第四项独占新的一行 */
    padding-left: 8vw;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue